import type { OriginalItemTypes } from "@memorang/types";

export const splitLayoutItemTypes = new Set<OriginalItemTypes>([
	"MCSAR",
	"MCMAR",
	"MCSAR_CORE",
	"MCMAR_CORE",
]);
